import { ReportEntityType, ReportProduct, ReportWorkbook } from '../types';
import KEY_REPORT_EXPORT_MAP from './KeyboardingReport';

const EXPORT_REPORT_MAP: {
  [key in ReportProduct]?: { [key in ReportEntityType]?: ReportWorkbook<any> };
} = {
  [ReportProduct.KEY]: KEY_REPORT_EXPORT_MAP
  //[ReportProduct.WDT]: WDT_REPORT_EXPORT_MAP
};

export default EXPORT_REPORT_MAP;
